import * as React from "react";
import type { SVGProps } from "react";
export const SvgYearInReviewJungle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 30 30" {...props}>
    <path
      fill="currentColor"
      d="M5.771 0s16.07 16.747 9.62 30c-.021-.027-4.54-5.863-9.958-8.527 0 0 .905-7.912-5.433-13.152 0 0 8.601 3.699 10.412 9.452C10.43 17.7 12.418 9.511 5.772 0ZM30 7.5s-6.45 5.753-5.318 12.842c0 0-4.527 2.671-5.32 4.315.002-.056.476-12.442 10.638-17.157ZM23.638 0c-.027.047-4.978 8.648-4.527 15 0 0-1.018 1.438-1.358 2.67-.014-.052-1.25-4.73-2.263-5.855 0 0 4.187-8.116 8.148-11.815Z"
    />
  </svg>
);
